const en = {
  title: "Traditional Chinese Medicine Knowledge Graph Intelligent Q&A System",
  intro: "Introduction",
  print: "Print",
  send: "Send",
  inputPlaceholder: "Please enter your question",
  voiceInput: "Voice input",
  clearMessage: "Clear chat history and graph",
  cancel: "Cancel",
  confirm: "Confirm",
  text: "The Traditional Chinese Medicine Knowledge Graph Intelligent Q&A System utilizes advanced artificial intelligence technologies such as large language models and knowledge graphs. It achieves intelligent question-answering in the field of Traditional Chinese Medicine, and is capable of intelligently recommending traditional Chinese medicine prescriptions based on user-described symptoms. This system forms an intelligent expert system for professional knowledge in Traditional Chinese Medicine.",
  ref: "Reference",
};
export default en;
